import { Route, Redirect } from "react-router-dom";

function AdminRoute({ component: Component, ...rest }) {
  const savedEmail = localStorage.getItem("email");

  return (
    <Route
      {...rest}
      render={(props) =>
        savedEmail === "tai.nguyennhu2204@gmail.com" ? (
          <Component {...props} />
        ) : (
          <Redirect to="/" />
        )
      }
    />
  );
}
export default AdminRoute;
